/* eslint-disable import/prefer-default-export */
import GoogleTagManager from 'components/GoogleTagManager';
import Parsely from 'components/Parsely';
import PinterestConversionTag from 'components/PinterestConversionTag';
import Permutive from 'components/Permutive';
import FacebookPixel from 'components/FacebookPixel';
import Sailthru from 'components/Sailthru';
import { SITE_ORIGIN } from 'constants/site';

export const ANALYTICS_DELAY = 100; // ms

/**
 * defines a "pageview" event and what happens analytics-wise for it.
 *
 * @export
 * @param {String} path page path, including query string
 * @param {Object} metadata
 * @param {String} pageType type of page. used for contentGroup1 in GA
 * @param {String} httpStatus descriptive HTTP status message (CODE: msg)
 * @param {String[]} flips enabled feature flips
 * @param {String} ssrRenderDatetime datetime page was rendered in ISO 8601 format
 * @param {String} deployId version of the app running in prod
 * @param {String} surrogateKey surrogate key for URL
 */
export function registerPageview(
  path,
  metadata,
  pageType,
  httpStatus,
  flips,
  ssrRenderDatetime,
  deployId,
  surrogateKey,
  contentStats
) {
  // NOTE: Use timeout to push this to the end of the execution stack. It's not
  // ideal but it ensures the head has been updated before it is called. This
  // is likely due to how next handles updating the head, and wouldn't normally
  // be necessary for components using the React lifecycle.
  //
  // NOTE: this delay also helps mitigate an issue with the pageLoaded event
  // getting called before react has updated the DOM.
  //
  // NOTE: this delay can't be good for timing. :-(
  window.setTimeout(() => {
    const { title } = metadata;

    GoogleTagManager.triggerPageLoaded(
      path,
      metadata,
      pageType,
      httpStatus,
      flips,
      ssrRenderDatetime,
      deployId,
      surrogateKey,
      contentStats
    );
    Permutive.pageView();
    Parsely.pageView(path, title);
    PinterestConversionTag.pageView();
    FacebookPixel.pageView();

    const pageUrl = new URL(path, SITE_ORIGIN);

    // we only want to track HTTP 200 pages that are NOT previews
    const isTrackablePage =
      httpStatus.startsWith('200') && !pageUrl.searchParams.get('preview');

    if (isTrackablePage) {
      Sailthru.pageView(path);
    }
  }, ANALYTICS_DELAY);
}

/**
 * defines a "bundles loaded" event and what happens analytics-wise for it.
 *
 * @export
 * @param {Number} bundleCount number of bundles now present in page
 */
export function registerBundlesLoaded(bundleCount) {
  GoogleTagManager.triggerBundlesLoaded(bundleCount);
}
